/**
 * Route for `magento-connector`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { MagentoConnectorPage } from "../features/magento-connector/MagentoConnectorPage";

export const magentoConnectorRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/magento-connector",
	component: MagentoConnectorPage,
});

export default magentoConnectorRoute;
